<template>
    <div class="board">
        <div class="bar">
            <b-icon icon="file-earmark-text" class="icon"></b-icon>
            <span>ประวัติการเข้ารับบริการ</span>
        </div>
        
        <div class="content">
            <div class="top-option-block mb-4">
                <button :class="{ 'active': typeActive === $Constants.JOB_TYPE_ORDER }" @click="setActiveOption($Constants.JOB_TYPE_ORDER)">รายการสั่งซื้อ</button>
                <button :class="{ 'active': typeActive === $Constants.JOB_TYPE_SERVICE }" @click="setActiveOption($Constants.JOB_TYPE_SERVICE)">รายการตรวจและบริการ</button>
                <button :class="{ 'active': typeActive === $Constants.JOB_TYPE_CLAIM }" @click="setActiveOption($Constants.JOB_TYPE_CLAIM)">รายการขอเคลม</button>
            </div>

            <template v-if="typeActive === $Constants.JOB_TYPE_ORDER">
                <customer-list-order ref="refListOrder" :jobList="jobList"></customer-list-order>
            </template>

            <template v-if="typeActive === $Constants.JOB_TYPE_SERVICE">
                <customer-list-service ref="refListService" :jobList="jobList"></customer-list-service>
            </template>

            <template v-if="typeActive === $Constants.JOB_TYPE_CLAIM">
                <customer-list-claim ref="refListClaim" :jobList="jobList"></customer-list-claim>
            </template>
        </div>
    </div>
</template>

<script>
import CustomerListOrder from '@/components/customer/ListOrder';
import CustomerListService from '@/components/customer/ListService';
import CustomerListClaim from '@/components/customer/ListClaim';
import DBJob from '@/database/Job';
import DBCustomer from '@/database/Customer';

export default {
    components: {
        CustomerListOrder,
        CustomerListService,
        CustomerListClaim
    },
    data() {
        return {
            typeActive: -1,
            jobList: []
        }
    },
    async mounted() {
        this.jobList = await this.loadJobList();
        
        this.setActiveOption(this.$Constants.JOB_TYPE_ORDER);
    },
    methods: {
        setActiveOption(type) {
            this.typeActive = type;
        },
        async loadJobList() {
            const keyData = this.$route.params.key;
            let result = [];

            if (keyData) {
                const loader = this.$AppUtility.renderLoadBackdrop();
                const customerData = await DBCustomer.getDetail(keyData);
                const allJob = await DBJob.get();

                if (allJob.content && allJob.content.length > 0) {
                    // Filter only current customer
                    result = allJob.content.filter(x => x.customer.licensePlate === customerData.licensePlate
                                                        && x.customer.licensePlateProvince === customerData.licensePlateProvince);
                }

                loader.hide()
            }

            return result;
        }
    }
}
</script>